const APIConfig = require("apiconfig");
const BaseModel = require("./base_model");

module.exports = BaseModel.extend({
  urlRoot: `${APIConfig.host}teammates`,
  idAttribute: "username",
  excludes: ["user_type", "is_owner", "persona"],

  parse(data) {
    data.is_owner = data.user_type === "owner";
    return data;
  },

  validate(attrs, options) {
    if (this.isNew() && (!attrs.email || attrs.email.length === 0)) {
      return { field: "email", message: "email address is required" };
    }

    if (!attrs.is_admin && (!attrs.scopes || attrs.scopes.length === 0)) {
      return {
        field: "scopes",
        message: "either select Admin or select at least one permission",
      };
    }
  },
});
